import { useDispatch, useSelector } from 'react-redux';
import UserSelector, * as Users from 'redux/Users';
import Notifications from 'redux/Notifications';

const useUsers = () => {
  const dispatch = useDispatch();
  const isFetchingUsers = useSelector(UserSelector.getIsFetching);
  const selectedUser = useSelector(UserSelector.getSelectedUser);
  const users = useSelector(UserSelector.getUsersPage);
  const userOrgName = useSelector(UserSelector.getUserOrgName);
  const filterByOrg = useSelector(UserSelector.getFilterByOrg);
  const getError = useSelector(UserSelector.getError);
  const filteredUsersByOrg = useSelector(UserSelector.filteredUsers);
  const clearErrors = () => {
    dispatch(Notifications.clearAllNotification());
    dispatch(UserSelector.clearErrors());
  };

  const fetchUsers = (organization_id) => {
    if (!users || users?.length === 0) {
      dispatch(Users.startFetch());
      dispatch(Users.fetchUsers({ organization_id: organization_id })).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const setUserOrgName = (name) => {
    dispatch(UserSelector.setUserOrgName(name));
  };

  const saveUser = (user) => {
    if (user.user_id) {
      return dispatch(Users.updateUser(user)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
    return dispatch(Users.createUser(user)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const setSelectedUser = (userId) => {
    dispatch(Users.selectUser(userId));
  };

  const setFilterByOrg = (filter) => {
    dispatch(UserSelector.setFilterByOrg(filter));
  };

  const userRequestPasswordReset = (email, clientId) => {
    return dispatch(Users.userRequestPasswordReset(email, clientId)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const userResetPassword = (passwordObj, token) => {
    return dispatch(Users.userResetPassword(passwordObj, token)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const userInviteRequest = (email, clientId, user) => {
    dispatch(Users.startFetch());
    return dispatch(Users.userInviteRequest(email, clientId, user)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const userCompleteRegistration = (user, token) => {
    dispatch(Users.startFetch());
    return dispatch(Users.userCompleteRegistration(user, token)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  return {
    users,
    fetchUsers,
    setUserOrgName,
    filterByOrg,
    filteredUsersByOrg,
    selectedUser,
    isFetchingUsers,
    setFilterByOrg,
    userOrgName,
    setSelectedUser,
    userInviteRequest,
    userCompleteRegistration,
    saveUser,
    userRequestPasswordReset,
    userResetPassword,
    getError,
    clearErrors,
  };
};

export default useUsers;
